import useSession from "@utils/useSession";
import React, { FC } from "react";
import { useIdleTimer, useIdleTimerContext } from "react-idle-timer";
import { useLocation, useNavigate } from "react-router-dom";
import { appInsights } from "../appInsights";
import sessionService from "@services/session.service";
import authService from "@services/auth.service";
import { routeMap } from "@utils/constants";
import moment from "moment";

const UserActivityHOC: FC<any> = (props: any) => {
  // const activeEventEmitterTimer = 5 * 60 * 1000;
  // User Activity Idle Timer duration ( 5 min )
  const userActivityTimeOut = 5 * 60 * 1000;
  // const userActivityTimeOut = 10000;

  const navigate = useNavigate();
  const location = useLocation();
  const session = useSession();
  const idleTimer = useIdleTimerContext();

  const onIdleUserLogout = () => {
    if (session.isLoggedIn) {
      props.setSessionTimeoutModal(true);
      sessionStorage.setItem("forcedLogout", "true");
      const lastActiveTime = moment(getLastActiveTime()).format("MM/DD/YYYY hh:mm:ss A");
      const totalActiveTime = `${(getTotalActiveTime() / (1000 * 60))?.toFixed(2)} minutes`;
      appInsights.trackEvent({
        name: `${session?.user?.email} is force logged out from tab ${idleTimer?.getTabId()}, as user idle since ${lastActiveTime}`,
        properties: {
          url: location.pathname,
          totalActiveTimeInSession: totalActiveTime,
          tabId: idleTimer?.getTabId(),
          isLeader: idleTimer?.isLeader(),
        },
      });
      appInsights.trackPageView({ name: "User Idle Logout" });
      appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
      authService.logout().subscribe({
        next: () => {
          session.logout();
          appInsights.clearAuthenticatedUserContext();
          navigate(routeMap["home"]);
        },
        error: () => {},
      });
    }
  };

  /**
   * Hook from react-idle-timer to track user behavior on the website
   * Timeout is the time in millisecond to set the timeout
   */
  const { getLastActiveTime, getRemainingTime, getTotalActiveTime, getLastIdleTime } = useIdleTimer({
    // timeout: 1000 * (process.env.REACT_APP_INACTIVITY_TIMEOUT_TIME ? Number(process.env.REACT_APP_INACTIVITY_TIMEOUT_TIME) : 30 * 60), //Time in millisecond
    // For Test Purpose timer use ->
    timeout: Number(process.env.REACT_APP_INACTIVITY_TIMEOUT_TIME),
    // timeout: 90000,
    onIdle: onIdleUserLogout,
    debounce: 500,
    name: "logout-timer",
    crossTab: true,
    syncTimers: 200,
  });

  // Application Event Tracking

  // const applicationOnActive = () => {
  //   console.log(isIdle())
  //   if (session.isLoggedIn) {
  //     if (getRemainingTime()) {
  //       const remainingTimeUntilIdle = (getRemainingTime() / (1000 * 60))?.toFixed(2);
  //       appInsights.trackEvent({
  //         name: `${session?.user?.email} is active on tab ${idleTimer?.getTabId()}`,
  //         properties: {
  //           url: location.pathname,
  //           remainingTimeUntilIdle: `${remainingTimeUntilIdle} minutes`,
  //           tabId: idleTimer?.getTabId(),
  //         },
  //       });
  //       appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
  //     }
  //   }
  // };

  const applicationOnIdle = () => {
    if (session.isLoggedIn) {
      if (session?.user?.email && session?.user?.email !== "") {
        const remainingTimeUntilIdle = (getRemainingTime() / (1000 * 60))?.toFixed(2);
        const lastActiveTime = moment(getLastActiveTime()).format("MM/DD/YYYY hh:mm:ss A");
        const lastIdleTime = moment(getLastIdleTime()).format("MM/DD/YYYY hh:mm:ss A");

        appInsights.trackEvent({
          name: `${session?.user?.email} is Idle on tab ${idleTimer?.getTabId()}, as user idle since ${lastActiveTime}`,
          properties: {
            url: location.pathname,
            remainingTimeUntilIdle: `${remainingTimeUntilIdle} minutes`,
            tabId: idleTimer?.getTabId(),
            isLeader: idleTimer?.isLeader(),
            lastActiveTime: lastActiveTime,
            lastIdleTime: lastIdleTime,
          },
        });
        appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
      }
    }
  };

  const activityTrackerTimer = useIdleTimer({
    // onActive: applicationOnActive,
    timeout: userActivityTimeOut,
    onIdle: applicationOnIdle,
    crossTab: true,
    syncTimers: 200,
    name: "activity-timer"
  });

  return <>{props?.children}</>;
};

export default UserActivityHOC;
